import { render, staticRenderFns } from "./UnitModel.vue?vue&type=template&id=5a7ed512&"
import script from "./UnitModel.vue?vue&type=script&lang=js&"
export * from "./UnitModel.vue?vue&type=script&lang=js&"
import style0 from "./UnitModel.vue?vue&type=style&index=0&id=5a7ed512&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports